<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="390"
    >
      <v-card>
        <v-card-title 
          class="text-h5"
          :style="{ fontFamily: FontContent }"
        >
          {{ $t('settings.formTerms.cookiePolicy') }}
        </v-card-title>
        <v-card-text :style="{ fontFamily: FontContent }">
          {{ $t('settings.formTerms.info') }}
        </v-card-text>
        <v-card-actions style="text-align: right">
          <terms-view
            :show="showCP"
            :cookiePolicy="cookiePolicy"
            :onClose="() => {showCP = false}"
          />
          <v-btn
            :color="BGColorSecundary"
            :style="{ color: ColorSecundary }"
            @click="showCP = true"
            x-small
            elevation="0"
          >
            {{ $t('settings.formTerms.learnMore') }}
          </v-btn>
          <v-btn
            :color="BGColor"
            :style="{ color: Color }"
            x-small
            elevation="0"
            @click="handleAgree"
          >
            {{ $t('settings.formTerms.agree') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import utilsService from '@/services/utils'
import constants from '@/constants'
import api from '@/services/api'
import TermsView from './Terms'
export default {
  components: {
    TermsView,
  },
  props: {
    workspaceID: {
      type: String,
      requried: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    showCookiePolicy: false,
    cookiePolicy: null,
    showCP: false,
  }),
  computed: {
    ...mapState('app',['FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary']),
    isSimulation () {
      return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
    },
  },
  watch: {
    workspaceID () {
      this.handleGetData()
    },
    locale () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      if (this.isSimulation) return

      const privacyAgree = utilsService.getCustomToken('privacy') ? utilsService.getCustomToken('privacy').split(',') : [] 
      if (privacyAgree.indexOf(this.workspaceID) >= 0) return
      
      api.getAll(`enterprises/terms/${this.workspaceID}`, false, 1, 100000, '')
        .then(response => {
          if (!response || response.length === 0) return
          const aux = response.shift()
          this.showCookiePolicy = aux.ShowCookiePolicy ? true : false
          this.cookiePolicy = aux.CookiePolicy ? utilsService.getTranslation(JSON.parse(aux.CookiePolicy), this.locale) : null 
          if (this.showCookiePolicy && this.cookiePolicy) this.dialog = true
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleAgree () {
      const privacyAgree = utilsService.getCustomToken('privacy') ? utilsService.getCustomToken('privacy').split(',') : [] 
      privacyAgree.push(this.workspaceID)
      utilsService.setCustomToken('privacy', privacyAgree.join(','))
      this.dialog = false
    },
  },
}
</script>

